export enum StepperBarStepsEnum {
  First = 1,
  Second = 2,
  Third = 3
}

export type StepperBarStepsEnumType = keyof typeof StepperBarStepsEnum;
